"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RecentDefenseList = exports.RecentDefense = void 0;
/** Information about a recent defense. */
class RecentDefense {
    constructor(eventId, team, overallSimilarity) {
        this.eventId = eventId;
        this.team = team;
        this.overallSimilarity = overallSimilarity;
    }
}
exports.RecentDefense = RecentDefense;
/** Information about recent defenses a team has played against. */
class RecentDefenseList {
    constructor(teamId, recentDefenses) {
        this.teamId = teamId;
        this.recentDefenses = recentDefenses;
    }
}
exports.RecentDefenseList = RecentDefenseList;
//# sourceMappingURL=recent_defense.js.map